module.exports = __webpack_public_path__ + "static/media/3 13 Tulleord Starter testen.0385435a.mp3";